<template>
  <div class="layout-wrap">
    <el-container class="layout">
      <el-aside width="200px" class="aside">
        <div class="logo">二手交易后台</div>
        <el-menu
          :default-active="$route.path"
          class="menu"
          background-color="#001529"
          text-color="#fff"
          active-text-color="#ffd04b"
          router
        >
          <el-menu-item index="/goods">
            <i class="el-icon-goods"></i>
            <span slot="title">商品管理</span>
          </el-menu-item>
          <el-menu-item index="/banner">
            <i class="el-icon-picture"></i>
            <span slot="title">轮播图管理</span>
          </el-menu-item>
          <el-menu-item index="/points-records">
            <i class="el-icon-tickets"></i>
            <span slot="title">积分记录</span>
          </el-menu-item>
          <el-menu-item index="/notifications">
            <i class="el-icon-bell"></i>
            <span slot="title">通知管理</span>
          </el-menu-item>
          <el-menu-item index="/user">
            <i class="el-icon-user"></i>
            <span slot="title">用户信息管理</span>
          </el-menu-item>
          <el-menu-item index="/service">
            <i class="el-icon-setting"></i>
            <span slot="title">配置管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="header">
          <div class="header-left">欢迎进入二手交易小程序后台管理系统</div>
          <div class="header-right">
            <el-button type="text" @click="openChangePassword">修改密码</el-button>
            <el-button type="text" @click="handleLogout">退出登录</el-button>
          </div>
        </el-header>
        <el-main class="main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      @closed="resetPasswordForm"
    >
      <el-form ref="passwordFormRef" :model="passwordForm" :rules="passwordRules" label-width="90px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" show-password autocomplete="off" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" show-password autocomplete="off" />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" show-password autocomplete="off" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="passwordSubmitting" @click="submitPasswordChange">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/utils/http'

export default {
  name: 'IndexPage',
  data () {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      passwordDialogVisible: false,
      passwordSubmitting: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '新密码至少 6 位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogout () {
      localStorage.removeItem('token')
      localStorage.removeItem('adminId')
      this.$message.success('已退出登录')
      this.$router.replace('/login')
    },
    openChangePassword () {
      this.passwordDialogVisible = true
    },
    submitPasswordChange () {
      this.$refs.passwordFormRef.validate(async (valid) => {
        if (!valid || this.passwordSubmitting) return

        this.passwordSubmitting = true
        try {
          const adminId = localStorage.getItem('adminId') || localStorage.getItem('adminUsername')
          await http.put('/api/admin/change-password', {
            adminId,
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          })
          this.$message.success('密码修改成功，请使用新密码重新登录')
          this.passwordDialogVisible = false
          this.handleLogout()
        } catch (error) {
          console.error('修改密码失败', error)
          this.$message.error(error.message || '修改密码失败')
        } finally {
          this.passwordSubmitting = false
        }
      })
    },
    resetPasswordForm () {
      this.$refs.passwordFormRef && this.$refs.passwordFormRef.resetFields()
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  }
}
</script>

<style scoped>
.layout {
  height: 100vh;
}

.aside {
  background: #001529;
  color: #fff;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}

.menu {
  border-right: none;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}

.main {
  background: #f0f2f5;
}
</style>
